import { IxTree } from './IxTree.js';

customElements.define('ix-tree', IxTree);
